import { repositoryActions } from '../services';

export const validateResponse = ( dispatch ) => ( data ) => {
  if ( data && data.type === repositoryActions( 'message' ).SET ) {
    dispatch( data );
    throw data.message;
  }
  return data;
};